/* global tinymce */

import React from 'react';
import { connect } from 'react-redux';
import Model from '../../utils/model';
import ObjectEditor from './object-editor';
import ListEditor from './list-editor';
import { append } from 'ramda';

class DefaultObjectDataEditor extends React.Component {

    constructor(props) {
        super(props);
        this.state = { typeElementId: null };

        // We need this for keeping track of
        // TinyMCE instances that are being used
        // in the object/list value editors
        this.editors = [];

        this.onChange = this.onChange.bind(this);
        this.isLoading = this.isLoading.bind(this);
    }

    componentDidMount() {
        const defaultObjectDataComponent = manywho.model.getComponentByName('Default ObjectData', this.props.flowKey);
        const state = manywho.state.getComponent(this.props.id, this.props.flowKey);

        if (defaultObjectDataComponent.objectData != null && !state.isDirty) {
            manywho.state.setComponent(
                this.props.id,
                { contentValue: JSON.stringify(Model.fromModel(defaultObjectDataComponent.objectData)) },
                this.props.flowKey,
                false,
            );
        }
    }

    componentWillReceiveProps() {
        if (this.props.isDesignTime) {
            return;
        }

        const model = manywho.model.getComponent(this.props.id, this.props.flowKey);
        const type = model.tags.find(tag => tag.developerName === 'Form Editor').objectData;

        if (!manywho.utils.isPlaceholderObjectData(type)) {
            const typeElementId = manywho.utils.getObjectDataProperty(type[0].properties, 'Id').contentValue;
            this.setState({ typeElementId });
        }
    }

    componentWillUnmount() {
        // Destroying all instances of tinyMCE
        // used by the object/list value editor
        this.editors.forEach((editor) => {
            tinymce.get(editor).remove();
        });

        this.editors = [];
    }

    onChange({ objectData }) {
        if (objectData) {
            manywho.state.setComponent(this.props.id, { contentValue: JSON.stringify(objectData), isDirty: true }, this.props.flowKey, false);
        } else {
            manywho.state.setComponent(this.props.id, { contentValue: null, isDirty: true }, this.props.flowKey, false);
        }

        this.forceUpdate();
    }

    addEditor = (nodeId) => {
        const editors = append(nodeId, this.editors);
        this.editors = editors;
    }

    isLoading(loading) {
        manywho.state.setComponentLoading(this.props.id, loading && {}, this.props.flowKey);
        this.forceUpdate();
    }

    render() {
        manywho.log.info(`Rendering Default Object Data Editor: ${this.props.id}`);

        if (this.props.isDesignTime) {
            return null;
        }

        const model = manywho.model.getComponent(this.props.id, this.props.flowKey);
        const contentType = model.tags.find(tag => tag.developerName === 'Selected Value').contentValue;

        if ((manywho.utils.isEqual(contentType, manywho.component.contentTypes.object, true)
            || manywho.utils.isEqual(contentType, manywho.component.contentTypes.list, true))
            && this.state.typeElementId) {

            const state = manywho.state.getComponent(this.props.id, this.props.flowKey);
            const defaultObjectDataComponent = manywho.model.getComponentByName('Default ObjectData', this.props.flowKey);

            let objectData = null;

            if (state.contentValue && state.isDirty) {
                objectData = JSON.parse(state.contentValue);
            } else if (defaultObjectDataComponent.objectData !== null && !state.isDirty) {
                objectData = Model.fromModel(defaultObjectDataComponent.objectData);
            }

            if (objectData) {
                // Add a unique id to each row for react `key` prop, preserving existing `key` values to avoid re-renders
                objectData = objectData.map(item => ({ ...item, key: item.key ? item.key : manywho.utils.guid() }));
            }
            let editor = null;

            if (manywho.utils.isEqual(contentType, manywho.component.contentTypes.object, true)) {
                editor = (
                    <ObjectEditor
                        typeElementId={this.state.typeElementId}
                        objectData={objectData}
                        onChange={this.onChange}
                        flowKey={this.props.flowKey}
                        authenticationToken={this.props.authenticationToken}
                        tenantId={this.props.tenantId}
                        isLoading={this.isLoading}
                        key={this.state.typeElementId}
                        addEditor={this.addEditor}
                    />
                );
            } else {
                editor = (
                    <ListEditor
                        typeElementId={this.state.typeElementId}
                        objectData={objectData}
                        onChange={this.onChange}
                        flowKey={this.props.flowKey}
                        authenticationToken={this.props.authenticationToken}
                        tenantId={this.props.tenantId}
                        isLoading={this.isLoading}
                        key={this.state.typeElementId}
                        addEditor={this.addEditor}
                    />
                );
            }

            return (
                <div className="default-objectdata-editor">
                    <span>Default Object Data</span>
                    {editor}
                    {React.createElement(manywho.component.getByName('wait'), { isVisible: state.loading }, null)}
                </div>
            );
        }
        return null;
    }
}

export default connect(
    ({ currentUser: { authenticationToken, tenantId } }) => ({ authenticationToken, tenantId }),
    null,
    null,
    {
        pure: false, 
    },
)(DefaultObjectDataEditor);
